import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { AbstractControl, FormArray } from '@angular/forms';

/**
 * Lista reordenable de nodos (`cdkDropList`, S4.4). El reordenamiento visual
 * NO tiene ningún significado estructural para el backend — el grafo se
 * define por `siguienteNodoId`/`destinoNodoId`, no por posición en la
 * lista — así que mover una tarjeta acá es puramente cosmético/organizativo
 * para quien edita, y `moveItemInArray` alcanza para mantener el
 * `FormArray` y la vista sincronizados sin reconstruir controles.
 */
@Component({
    selector: 'app-flujo-nodo-lista',
    templateUrl: './flujo-nodo-lista.component.html',
})
export class FlujoNodoListaComponent {

    @Input() nodosFormArray!: FormArray;
    @Input() nodoInicialId: string | null = null;
    /** Botón que lleva a cada paso, por id de paso. Titula la tarjeta por su causa. */
    @Input() disparadores: Record<string, string> = {};
    /** Ids de pasos desde los que ningún camino llega a un END/HANDOFF. */
    @Input() nodosSinFinal: Set<string> = new Set();
    /** Ids de pasos a los que ningún camino desde el inicio llega. */
    @Input() nodosInalcanzables: Set<string> = new Set();

    @Output() editarNodo = new EventEmitter<number>();
    @Output() eliminarNodo = new EventEmitter<number>();

    get controles(): AbstractControl[] {
        return this.nodosFormArray?.controls || [];
    }

    esInicial(control: AbstractControl): boolean {
        return control.get('id')?.value === this.nodoInicialId;
    }

    disparadorDe(control: AbstractControl): string {
        return this.disparadores[control.get('id')?.value] || '';
    }

    sinFinalDe(control: AbstractControl): boolean {
        return this.nodosSinFinal.has(control.get('id')?.value);
    }

    inalcanzableDe(control: AbstractControl): boolean {
        return this.nodosInalcanzables.has(control.get('id')?.value);
    }

    onDrop(event: CdkDragDrop<AbstractControl[]>): void {
        if (event.previousIndex === event.currentIndex) {
            return;
        }

        const control = this.nodosFormArray.at(event.previousIndex);
        this.nodosFormArray.removeAt(event.previousIndex);
        this.nodosFormArray.insert(event.currentIndex, control);
    }
}
